import { render, staticRenderFns } from "./IndustryProfile.vue?vue&type=template&id=8bfe4266&scoped=true&"
import script from "./IndustryProfile.vue?vue&type=script&lang=js&"
export * from "./IndustryProfile.vue?vue&type=script&lang=js&"
import style0 from "./IndustryProfile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./IndustryProfile.vue?vue&type=style&index=1&id=8bfe4266&lang=less&scoped=true&"
import style2 from "./IndustryProfile.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfe4266",
  null
  
)

export default component.exports